import type { ComponentChildren } from "preact";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useDocumentTitle } from "../../lib/use-document-title";
import { cn } from "./cn";

export function PageHeader({
  backHref,
  backLabel,
  title,
  monoTitle = false,
  description,
  actions,
  onBackClick,
  class: extraClass,
}: {
  backHref?: string;
  backLabel?: ComponentChildren;
  title: ComponentChildren;
  monoTitle?: boolean;
  description?: ComponentChildren;
  actions?: ComponentChildren;
  onBackClick?: (e: MouseEvent) => void;
  class?: string;
}) {
  // When title is a plain string, mirror it to document.title automatically
  // so every PageHeader-driven screen gets a tab label without extra wiring.
  // Pass null when title is JSX — those screens should set the title manually.
  useDocumentTitle(typeof title === "string" ? title : null);
  return (
    <header class={cn("space-y-2", extraClass)}>
      {backHref && (
        <a
          href={backHref}
          onClick={onBackClick}
          class="inline-flex items-center gap-1 text-xs font-medium text-fg-subtle transition hover:text-fg"
        >
          <ArrowLeftIcon class="h-3.5 w-3.5" />
          {backLabel ?? "戻る"}
        </a>
      )}
      <div class="flex flex-wrap items-start justify-between gap-3">
        <div class="min-w-0 space-y-1">
          <h1
            class={cn(
              "text-2xl font-semibold tracking-tight text-fg",
              monoTitle && "font-mono",
            )}
          >
            {title}
          </h1>
          {description && (
            <div class="text-sm text-fg-subtle">{description}</div>
          )}
        </div>
        {actions && (
          <div class="flex flex-wrap items-center gap-2">{actions}</div>
        )}
      </div>
    </header>
  );
}
